import React from "react"
import clsx from "clsx"
import DateHelper from "../../DateHelper/DateHelper";
import AuthenticationStatusViewer from "../../AuthenticationStatusViewer/AuthenticationStatusViewer";
//import I18n from "i18n-js/index.js.erb"

class CustomerPresenterGeneral extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return(
      <div className={tabClasses} id="general">
        <p>
          <strong>{I18n.t('salutation')}</strong> 
          : {this.props.salutation}
        </p>
        <p>
          <strong>{I18n.t('first_name')}</strong> 
          : {this.props.first_name}
        </p>
        <p>
          <strong>{I18n.t('middle_name')}</strong> 
          : {this.props.middle_name}
        </p>
        <p>
          <strong>{I18n.t('last_name')}</strong> 
          : {this.props.last_name}
        </p>
        <p>
          <strong>{I18n.t('email_address')}</strong> 
          : {this.props.email}
        </p>
        <p>
          <strong>{I18n.t('mobile_number')}</strong> 
          : {this.props.formatted_phone}
        </p>

        <hr />

        <p>
          <strong>{I18n.t('address_1')}</strong> 
          : {this.props.address_1}
        </p>
        <p>
          <strong>{I18n.t('address_2')}</strong> 
          : {this.props.address_2}
        </p>
        <p>
          <strong>{I18n.t('city')}</strong> 
          : {this.props.city}
        </p>
        <p>
          <strong>{I18n.t('state_province')}</strong> 
          : {this.props.state}
        </p>
        <p>
          <strong>{I18n.t('postal_code')}</strong> 
          : {this.props.postal_code}
        </p>
        <p>
          <strong>{I18n.t('country')}</strong> 
          : {this.props.country}
        </p>

        {this.renderForms()}
        
        <hr />

        <p>
          <strong>{I18n.t('marketing_opt_in')}</strong> 
          : {this.props.marketing_opt_in ? I18n.t('yes') : I18n.t('no')}
        </p>

        <hr />

        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label>{I18n.t('status')}</label>
              <br />
              <div style={{ textTransform: 'capitalize' }}>{this.props.customer.status}</div>         
            </div>
            {this.props.customer.id ? <AuthenticationStatusViewer {...this.props} email={this.props.customer && this.props.customer.email ? this.props.customer.email : ''} readOnly={true} /> : null}
          </div>
        </div>
      

      </div>
    ) 
  }

  renderForms() {
    if(this.props.forms) {
      var title = ""
      var forms = this.props.forms.map((form, idx) => {
        if(form.no_fields != true) {
          form.map((form_field) => {
             title = form_field.form_title
          })
        } else {
          title = form.form.title
        }
        return (
          <fieldset className="field-group" key={idx}>
              <legend>{title}</legend>
              { form.no_fields != true ? this.renderFormFields(form) : null}
          </fieldset>
        )
      })
      return (
        <div>
          {forms}
        </div>
      )
    }
  }

  renderFormFields(form) {
    var formFields = form.map((form_field, idx) => {
      var form_field_answer = null
      var number_field_answer = null
      var date_field_answer = null
      if(this.props.answers) {
        var customerAnswers = this.props.answers
        customerAnswers.map((answer) => {
          if(answer.form_field_id == form_field.id){
            if(answer.number_answer) {
              number_field_answer = answer.number_answer
            } else if(answer.date_answer) {
              date_field_answer = answer.date_answer
            } else {
              form_field_answer = answer.answer
            }
          }
        })
      }

      if(form_field.field_type == "text_field_single_line") {
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              <div className="form-group">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <div>
                  {form_field_answer}
                </div>
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "select_box") {
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              <div className="form-group ">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <div>
                  {form_field_answer}
                </div>
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "number_input") {
        return (
          <div className='row' key={idx}>
            <div className="col-lg-6">
              <div className="form-group">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <div>
                  {number_field_answer}
                </div>
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "date_form_field") {
        date_field_answer && typeof date_field_answer == 'string' ? date_field_answer = DateHelper.parseDateFromBackend(date_field_answer) : null;
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              <div className="form-group">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <div>{DateHelper.printDateToScreen(date_field_answer, this.props.date_format)}</div>
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "text_area_multi_line") {
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              <div className="form-group">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <div>
                  {form_field_answer}
                </div>
              </div>
            </div>
          </div>
        )
      }

      if(form_field.field_type == "phone_number") {
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
              <div className="form-group">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <div>
                  {form_field_answer}
                </div>
              </div>
            </div>
          </div>
        )
      }
      
      if(form_field.field_type == "numbered_scale") {
        var current_rating_answer = []
        if(this.props.rating_answers.length > 0) {

          this.props.rating_answers.map((rating_answer) => {
            if(rating_answer.form_field_id == form_field.id) {
              current_rating_answer = rating_answer
            }
          })   
        } else {
          current_rating_answer = {
            answer: form_field_answer,
            selected: true
          }
        }
          
        return (
          <div className="row" key={idx}>
            <div className="col-lg-6">
    
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                {this.renderRatingRangeForm(form_field, current_rating_answer)}
                <br></br>
           

            </div>
          </div>
        )
      }

      if(form_field.field_type == "emoji_rating") {
        var current_emoji_answer = []
        if(this.props.emoji_answers.length > 0) {
          this.props.emoji_answers.map((emoji_answer) => {
            if(emoji_answer.form_field_id == form_field.id) {
              current_emoji_answer = emoji_answer 
            }
          })  
        } else {
          current_emoji_answer = {
            answer: form_field_answer,
            selected: true
          }
        }
        return (
          <div className="row"  key={idx}>
            <div className="col-lg-6">
                <label style={{whiteSpace: "pre-wrap", paddingBottom: "5px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                {this.renderEmojiRatingForm(form_field, current_emoji_answer)}
                <br></br>
            </div>
          </div>
        )
      }
    });

    return (
      <div>
        {formFields}
      </div>
    );
  }




 renderEmojiRatingForm(form_field, current_emoji_answer) {
    var rating_range = 5
    var rating_range_arr = []

    for(let index = 0; index < rating_range; index++) {
      rating_range_arr.push(index + 1)  
    }

    var rating_range_lines = rating_range_arr.map((rating) => {
    
      if(rating_range == 5) {
        if(rating == 1) {

          var list_emoji = <i className="far fa-frown-open fa-2x"></i>
        }
        else if(rating == 2) {

          var list_emoji = <i className="far fa-frown fa-2x"></i>
           
        } else if (rating == 3) {

          var list_emoji = <i className="far fa-meh fa-2x"></i>

        } else if (rating == 4) {

          var list_emoji = <i className="far fa-smile fa-2x"></i>
          
        } else {

          var list_emoji = <i className="far fa-grin fa-2x"></i>

        } 
      
      }
      
      return (
        <li className={rating == current_emoji_answer.answer && current_emoji_answer.selected == true  ? `selected-emoji-scale-li` : `emoji-scale-li`} key={rating}>{list_emoji}</li>
      )
    })
  
  if(this.props.rating_range != 'none') {

    return (
      <ul className="emoji-scale-ul">
        {rating_range_lines}
      </ul>
    )
  } 

}


renderRatingRangeForm(form_field, current_rating_answer) {
  if(form_field) {
    var rating_range = parseInt(form_field.rating_scale.rating_range, 10)
    var rating_range_arr = []
    for(let index = 0; index < rating_range; index++) {
      rating_range_arr.push(index + 1)  
    }
    var rating_range_lines = rating_range_arr.map((rating) => {
      if(rating_range == 10) {

        if(rating <= 3){
          var color = "#aa381d"
        } else if (rating > 3 && rating <= 6) {
          var color = "#d18140"
        } else if (rating > 3 && rating <= 6) {
          var color = "#bba350"
        } else {
          var color = "#61a544"
        }
      }

      if(rating_range == 5) {
        if(rating < 3){
          var color = "#aa381d"
        } else if (rating  == 3) {
          var color = "#bba350"
        } else if (rating > 3 && rating <= 6) {
          var color = "#61a544"
        } else {
          var color = "#61a544"
        }

      }
      
      return (
        <li className={rating == current_rating_answer.answer && current_rating_answer.selected == true ? "selected-rating-scale-li" : "rating-scale-li"} key={rating} style={{borderColor: color, color:color}}>{rating}</li>
      )
    })
  }
    if(this.props.rating_range != 'none') {

      return (
        <ul className="rating-scale-ul">
          {rating_range_lines}
        </ul>
      )
    } 

  }

}

export default CustomerPresenterGeneral